import "./Tooltip.css";
import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { observable } from "mobx";
import TooltipContent from "./TooltipContent";
import values from "lodash/values";
import classNames from "classnames";
import autobind from "autobind-decorator";
import enhanceWithClickOutside from "react-click-outside";

@observer
class Tooltip extends React.Component {
    @observable visible = false;

    static propTypes = {
        direction: PropTypes.oneOf(values(TooltipContent.Directions)),
        secondaryDirection: PropTypes.oneOf(values(TooltipContent.Directions)),
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        component: PropTypes.element,
        onHover: PropTypes.bool,
        className: PropTypes.string
    }

    @autobind
    handleClickOutside(e) {
        this.visible = false;
    }

    @autobind
    toggleVisible(e) {
        e.preventDefault();
        this.visible = !this.visible;
    }

    render() {
        const containerClasses = {
            tooltip: true,
            "has-label": this.props.label
        };

        return (
            <div
                className={classNames(containerClasses, this.props.className)}
                onMouseEnter={this.toggleVisible}
                onMouseLeave={this.toggleVisible}
            >
                <TooltipContent visible={this.visible} direction={this.props.direction} secondaryDirection={this.props.secondaryDirection}>
                    {this.props.children}
                </TooltipContent>
                {!this.props.component && (
                    <a href="#" onClick={!this.props.onHover && this.toggleVisible}>
                        {this.props.label ?
                            (<span className="tooltip-label">{this.props.label}</span>) :
                            (<div><i aria-label="Tooltip" className="icon-info-circled" /></div>)
                        }
                    </a>
                )}
                {this.props.component}
            </div>
        );
    }
}

Tooltip.Directions = TooltipContent.Directions;

export default enhanceWithClickOutside(Tooltip);
